import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LeiService from '../../../services/leis'
import Lei from './lei';
import Moment from 'moment';


const ListarLeis = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });


    const [leis, setLeis] = useState([]);
    const [vazio, setVazio] = useState(false);



    async function fetchLeisIn() {
        const response = await LeiService.categorias({categoria: "Lei Orçamentária Plurianual - PPA", limit: false});
        if (response.data.length >= 1) {
            setLeis(response.data)
            setVazio(false)
        } else {
            setLeis([])
            setVazio(true)
        }
    }


    useEffect(() => {
        fetchLeisIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setLeis={setLeis}
                    setVazio={setVazio}
                    fetchLeisIn={fetchLeisIn}
                    leis={leis}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {leis.map((lei, index) =>
                            <Lei
                                lei={lei}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarLeis;